<template>
  <v-card flat>
    <!-- <pic-selector
      v-if="computedValue && computedValue.hasOwnProperty('gallery')"
      v-model="computedValue.gallery"
      :edit-name="false"
      :default-cat-name="$t('logo')"
      single
    /> -->

    <pic-selector
      v-model="computedValue.gallery"
      :edit-name="false"
      :default-cat-name="$t('banner')"
      single
    />
  </v-card>
</template>

<script>
import picSelector from "../../../../components/UploadCenter/picSelector.vue";

export default {
  name: "logoSelect",

  components: { picSelector },

  props: {
    value: [Object, Array],
  },

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
